import { tone } from '../../shared/components/tokens.js';
import { usePortalPreview } from '../preview.js';
import { usePortalImageUrl, vehiclePhotoUrl } from '../usePortalImage.js';

/**
 * Photo du véhicule au portail (vague 4) : affichée seulement si l'API la renvoie (réglage
 * `showVehiclePhotoOnPortal` du garage). La photo du client n'est jamais demandée ni affichée ici.
 */
export function PortalVehiclePhoto({ alt }: { alt: string }) {
  const preview = usePortalPreview();
  const { ref, src } = usePortalImageUrl(preview ? preview.vehiclePhotoUrl('display') : vehiclePhotoUrl('display'));
  return (
    <div ref={ref} className={`mb-3 overflow-hidden rounded-2xl ${tone.surfaceMuted}`}>
      {src ? <img src={src} alt={alt} className="aspect-[4/3] w-full object-cover" /> : <div className="aspect-[4/3] w-full" />}
    </div>
  );
}
